export default function ArrowDropDown(props)
{
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentcolor">
    <path d="M7 10l5 5 5-5z"/>
  </svg>;
}
